import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdd2c43c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goVip && _ctx.goVip(...args))),
      class: "img",
      src: "https://lsjy-front.oss-cn-hangzhou.aliyuncs.com/activity/vipactivity/%E8%AF%A6%E6%83%85%E9%A1%B5%20%283%29.png\r\n",
      alt: "active img"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goVip && _ctx.goVip(...args)))
      }, "立即购买")
    ])
  ], 64))
}